import type { EntityType, WorkspaceCounts } from "@/lib/api/entities";
import {
	memoryBrowseTypeSearch,
	memoryCreateEntityTypeSearch,
} from "@/lib/memory-browse";

export function onboardingSteps(
	owner: string,
	counts: WorkspaceCounts,
	entityTypes: EntityType[],
	canCreateEntity: boolean,
) {
	const storedTypes = entityTypes.filter(
		(type) =>
			!type.slug.startsWith("$") &&
			!type.backing_sql &&
			(!type.organization_slug || type.organization_slug === owner),
	);
	const entityLink =
		storedTypes.length === 0
			? memoryCreateEntityTypeSearch(owner)
			: storedTypes.length === 1
				? {
						...memoryBrowseTypeSearch(owner, storedTypes[0].slug),
						search: { create: true },
					}
				: { to: "/$owner/data" as const, params: { owner } };

	return [
		{
			number: 1,
			label: "Connect an agent",
			complete: counts.agents + counts.clients > 0,
			link: { to: "/$owner/agents/connect" as const, params: { owner } },
		},
		{
			number: 2,
			label: "Add a connector",
			complete: counts.connections > 0,
			link: { to: "/$owner/connectors/create" as const, params: { owner } },
		},
		{
			number: 3,
			label: "Create an Automation",
			complete: counts.automations > 0,
			link: { to: "/$owner/automations/new" as const, params: { owner } },
		},
		...(canCreateEntity
			? [
					{
						number: 4,
						label: "Create an entity",
						complete: storedTypes.some((type) => (type.entity_count ?? 0) > 0),
						link: entityLink,
					},
				]
			: []),
	];
}
